export enum PaymentDayEnum {
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
}

export type IPaymentDay = 'Monday' | 'Tuesday' | 'Wednesday' | 'Thursday' | 'Friday' | PaymentDayEnum
